// extracted by mini-css-extract-plugin
module.exports = {"userSelectNone":"TableComponentFiltro_userSelectNone__13s6t","handCursor":"TableComponentFiltro_handCursor__12PKE"};